export default "__VITE_ASSET__mtseoJPt__"